import { createStyles } from "@mantine/core"

export const useStyles = createStyles(() => ({
    section: {
        display: "flex",
        flexDirection: "column",
        gap: ".75rem",
    },
}))
